// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"372":"b95e08916659f4a8","529":"c3c519abd2f07370","535":"0bf523c66d9d6a68","835":"ad784d2a42bf4757","895":"d35ff512fe7bdccb","908":"3f29b0884b6026d0"}[chunkId] + ".js";
};